"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BuildSignatureRequestType;
(function (BuildSignatureRequestType) {
    BuildSignatureRequestType["MESSAGE"] = "MESSAGE";
    BuildSignatureRequestType["EIP712"] = "EIP712";
})(BuildSignatureRequestType = exports.BuildSignatureRequestType || (exports.BuildSignatureRequestType = {}));
//# sourceMappingURL=BuildSignatureRequestType.js.map